import useGeoInput from '@/core/hooks/inputs/useGeoInput/useGeoInput';

export default useGeoInput;
